<template>
    <div>
        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
            <el-form-item label="客户名称" prop="customerId">
                <el-select v-model="form.customerId" placeholder="请选择代理商">
                    <el-option v-for="(item,index) in mediaCustomersData" :key="index" :label="item.name"
                               :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="广告类型" prop="type">
                <el-select v-model="form.type" placeholder="请选择广告类型">
                    <el-option label="首页媒体广告"
                               value="1"></el-option>
                    <el-option label="促销广告"
                               value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
                <el-input v-model="form.remark"></el-input>
            </el-form-item>
            <el-form-item label="日期" prop="advertisementEndTime">
                <el-date-picker type="date" placeholder="选择日期" v-model="form.advertisementEndTime" style="width: 100%;"></el-date-picker>
            </el-form-item>
        </el-form>
        <el-upload
                :show-file-list="false"
                action="/api/system/upload"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-success="handlePictureCardSuccess"
                :on-remove="handleRemove"
                >
            <img style="width: 145px;height: 145px;display: block;border-radius: 6px" v-if="dialogImageUrl" :src="dialogImageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <el-upload
                action="/api/system/upload"
                :on-remove="handleRemove"
                :on-success="handlePictureCardSuccess"
                :limit="3"
                :file-list="fileList">
            <el-button size="small" type="primary">点击上传视频</el-button>
        </el-upload>
    </div>
</template>
<script>
    import {saveMediaDelivery, getMediaDeliveryInfo} from "../../api/advertisingManagement";
    import {getMediaCustomersList} from "../../api/mediaCustomers";

    export default {
        props: {
            dataId: {
                type: String,
                default: () => {
                    return ""
                }
            }
        },
        data() {
            return {
                fileList:[],
                dialogImageUrl: '',
                dialogVisible: false,
                form: {
                    customerName: '',
                    customerPhone: '',
                    advertisementEndTime: '',
                    remark: '',
                    customerId: '',
                    fileId:'',
                    type:''
                },
                mediaCustomersData:[],
                rules: {
                    customerId: [
                        {required: true, message: '请输入经销商名称', trigger: 'blur'},
                    ],
                    customerPhone: [
                        {required: true, message: '请输入联系人', trigger: 'blur'},
                    ],
                    advertisementTimeLength: [
                        {required: true, message: '请输入联系地址', trigger: 'blur'},
                    ],
                    advertisementEndTime: [
                        {required: true, message: '请输入联系方式', trigger: 'blur'},
                    ],
                    remark: [
                        {required: true, message: '请输入联系方式', trigger: 'blur'},
                    ],
                    type: [
                        {required: true, message: '请输入选择广告类型', trigger: 'blur'},
                    ],
                }
            };
        },
        created() {
            getMediaCustomersList({
                page: 1,
                size: 99999
            }).then(res => {
                this.mediaCustomersData = res.data.listData
            });
            if (this.dataId !== '') {
                getMediaDeliveryInfo({
                    id: this.dataId
                }).then(res => {
                    res.data.advertisementEndTime =new Date(parseInt(res.data.advertisementEndTime)).Format('yy/MM/dd')
                    this.dialogImageUrl=res.data.fileUrl
                    this.form = res.data;
                })
            }

        },
        methods: {
            submitForm() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.form.advertisementEndTime=new Date(this.form.advertisementEndTime).Format('yy-MM-dd')
                        saveMediaDelivery(this.form).then(() => {
                            this.$message.success("保存成功");
                            this.$emit("handleCancel");
                            this.$emit("getList")
                        })
                    } else {
                        return false;
                    }
                });
            },
            resetForm() {
                this.$refs['form'].resetFields();
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
                this.form.fileIds=''
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handlePictureCardSuccess(response) {
                this.dialogImageUrl = response.data.url;
                this.form.fileId=response.data.fileId
            }
        }
    }
</script>